import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef } from '@angular/core';
import { Renderer } from '@df/ng/renderer';
import { ResultComponentDef } from '@df/ui/api/result.component.def';
import { CheckoutResultContentBlockComponent } from './checkout-result-content-block.component';

@Component({
    selector: 'checkout-result',
    template: '<span [innerHTML]="message"></span>',
    standalone: true,
    imports: [CommonModule]
})
export class CheckoutResultComponent extends ResultComponentDef {
    public constructor(
        ngEl: ElementRef,
        renderer: Renderer,
        _ref: ChangeDetectorRef,
        protected checkoutResultContentBlockComponent: CheckoutResultContentBlockComponent
    ) {
        super(ngEl, renderer, _ref);
    }

    protected override getMessage(): string {
        const superMessage = super.getMessage();

        if (superMessage && this.isSagepayColorDepthError(superMessage)) {
            const sagepayColorDepthMessage = this.getSagepayColorDepthErrorMessage();

            if (sagepayColorDepthMessage) {
                return sagepayColorDepthMessage;
            }
        }

        return superMessage;
    }

    protected getSagepayColorDepthErrorMessage(): string | undefined {
        return this.checkoutResultContentBlockComponent.content?.sagepay_color_depth_error_message;
    }

    protected isSagepayColorDepthError(error: string): boolean {
        return error.toLowerCase().indexOf('browsercolordepth') > -1;
    }
}
